module.exports = __webpack_public_path__ + "static/media/thermohug-2.a2e43f0a.jpg";